import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomepagebannerService {

  AppUrl = '';
  constructor(private readonly _httpClient: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  i360HomePageBannerAddUpdate(TokenKey: string, homePageBannerModel: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/HomePageBanner/i360HomePageBannerAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, homePageBannerModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360HomePageBannerGet(TokenKey: string, filterModel: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/HomePageBanner/i360HomePageBannerGet';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360HomePageBannerFindbyBannerId(TokenKey: string, BannerId: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/HomePageBanner/i360HomePageBannerFindbyBannerId/' + BannerId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360HomePageBannerDelete(TokenKey: string, BannerId: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/HomePageBanner/i360HomePageBannerDelete/' + BannerId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360HomePageBannerGetFront(): Observable<any> {
    this.setAPIUrl();
    const data = 'api/HomePageBanner/i360HomePageBannerGetFront';
    return this._httpClient.get<any>(this.AppUrl + data)
      .pipe(catchError(this.handleError));
  }

  i360HomePageBannerGetV2(TokenKey: string, filterModel: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/HomePageBanner/V2/i360HomePageBannerGet';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }
}
